var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tabs',{attrs:{"id":"request-type-radio-button","size":"small","tabBarStyle":{
    'borderBottom': 'none'
  },"tabBarGutter":0},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('a-tab-pane',{key:item.value,attrs:{"tab":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }